import { useEffect, useRef, useState } from "react";
import { Play, Pause, Loader2 } from "lucide-react";
import { useApi } from "@/lib/api";

export const RecordingButton = ({ sessionId, idx }) => {
  const api = useApi();
  const [state, setState] = useState("idle");
  const audio = useRef(null);
  useEffect(() => () => { audio.current?.pause(); if (audio.current?.src) URL.revokeObjectURL(audio.current.src); }, []);
  const toggle = async () => {
    if (state === "playing") { audio.current.pause(); return setState("idle"); }
    if (!audio.current) {
      setState("loading");
      try {
        const blob = await api("get", `/sessions/${sessionId}/turns/${idx}/audio`, undefined, { responseType: "blob" });
        audio.current = new Audio(URL.createObjectURL(blob));
        audio.current.onended = () => setState("idle");
      } catch { return setState("idle"); }
    }
    audio.current.play();
    setState("playing");
  };
  const Icon = state === "loading" ? Loader2 : state === "playing" ? Pause : Play;
  return (
    <button onClick={toggle} data-testid={`play-recording-${idx}`} className="inline-flex items-center gap-1 font-mono text-[10px] tracking-wider text-blue-400 hover:text-blue-300 border border-slate-800 px-2 py-1 transition-colors">
      <Icon className={`w-3 h-3 ${state === "loading" ? "animate-spin" : ""}`} /> RECORDING
    </button>
  );
};

export default function Transcript({ turns, autoScroll, sessionId }) {
  const end = useRef(null);
  useEffect(() => { if (autoScroll) end.current?.scrollIntoView({ behavior: "smooth" }); }, [turns.length, autoScroll]);
  return (
    <div className="flex-1 overflow-y-auto p-5 space-y-5" data-testid="transcript-list">
      {turns.map((t, i) => (
        <div key={i} className={`fade-up ${t.speaker === "user" ? "pl-6 border-l-2 border-blue-600" : ""}`} data-testid={`transcript-turn-${i}`}>
          <div className="flex items-center gap-3 mb-1">
            <span className={`font-mono text-[10px] tracking-[0.2em] ${t.speaker === "user" ? "text-blue-400" : "text-slate-500"}`}>{t.speaker === "user" ? "YOU" : "OFFICER QUIST"}</span>
            <span className="font-mono text-[10px] text-slate-600">{new Date(t.timestamp).toLocaleTimeString()}</span>
            {sessionId && t.audio_path && <RecordingButton sessionId={sessionId} idx={i} />}
          </div>
          <p className={`font-mono text-sm leading-relaxed ${t.speaker === "user" ? "text-white" : "text-slate-300"}`}>{t.text || <em className="text-slate-600">[no speech detected]</em>}</p>
        </div>
      ))}
      <div ref={end} />
    </div>
  );
}
